import React from 'react';
import { Tabs } from '@weave/design-system';
import { ChecklistActiveTab } from '../../handoff-checklist-v2.types';
import { css } from '@emotion/core';

interface MetricsTabsProps {
  activeTab: ChecklistActiveTab;
  onChange: (tab: ChecklistActiveTab) => void;
  blockedCount: number;
}

export const MetricsTabs = ({ activeTab, onChange, blockedCount }: MetricsTabsProps) => {
  return (
    <Tabs
      initialTab={activeTab}
      controlledTab={activeTab}
      onChange={(tab) => onChange(tab as ChecklistActiveTab)}
    >
      <Tabs.Bar>
        <Tabs.Tab id="all" controls="all-panel" css={styles.tab}>
          All
        </Tabs.Tab>
        <Tabs.Tab id="blocked" controls="blocked-panel" css={styles.tab}>
          Blocked {blockedCount > 0 && `(${blockedCount})`}
        </Tabs.Tab>
      </Tabs.Bar>
    </Tabs>
  );
};

const styles = {
  tab: css`
    flex: 1;
  `,
};
